import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslations } from '@lang';
import { InfoBox } from '../../../index';

const InfoBoxStyled = styled.div`
  padding-top: 1px;
  margin-left: 40px;
  margin-right: 40px;
`;

export const NoAvailability: FC<{ showNoAvailabilityMessage: boolean | 0 | undefined }> = ({
  showNoAvailabilityMessage,
}) => {
  const { t } = useTranslations();

  return showNoAvailabilityMessage ? (
    <InfoBoxStyled>
      <InfoBox>{t('room.updateSearch')}</InfoBox>
    </InfoBoxStyled>
  ) : null;
};
